import React from "react";

export const ShippingMethodHeader = ({totalShippingByLabel, fee, shippingMethod}) => (
  <div className="card-wrapper__header">
    <div className="card-wrapper__header-title">
      <ShippingMethodDelivery shippingMethodLabel={fee.shippingMethodLabel}
                              bundled={fee.bundled}/>
    </div>
    <ShippingFeesPrice totalShippingByLabel={totalShippingByLabel} price={fee.price} priceFormatted={fee.priceFormatted}
                       shippingMethod={shippingMethod} feesIncluded={fee.feesIncluded}/>
  </div>
);

const ShippingMethodDelivery = ({shippingMethodLabel, bundled}) => (
  <>
    <h2 className="title-medium text-orange">
      {shippingMethodLabel !== undefined && shippingMethodLabel}
      {shippingMethodLabel !== undefined && bundled ? (
        ` (${window.trans('front.javascript.product.bundled')})`
      ) : ""}
    </h2>
  </>
);

const ShippingFeesPrice = ({totalShippingByLabel, price, priceFormatted, shippingMethod, feesIncluded}) => {
  let priceText = '';
  let stageText = '';

  if (!feesIncluded && shippingMethod === undefined) {
    return (
      <></>
    );
  }

  if (feesIncluded || price === null) {
    priceText = window.trans('front.order.checkout.shipping_step.fee.included');
  } else if (parseInt(price) === 0) {
    priceText = window.trans('front.order.checkout.shipping_step.fee.free');
  } else if (parseInt(price) > 0) {
    priceText = totalShippingByLabel[shippingMethod.label] || priceFormatted;
    const lastStage = shippingMethod.stages.slice(-1).pop();
    if (lastStage !== undefined && parseInt(lastStage.price) < parseInt(price)) {
      if (lastStage.minValue !== undefined) {
        stageText = window.trans('front.order.checkout.shipping_step.fee.stage', {
          '{{ amount }}': parseInt(lastStage.price) === 0 ? window.trans('front.order.checkout.shipping_step.fee.free') : lastStage.priceFormatted,
          '{{ next_stage_amount }}': lastStage.minValue
        })
      }
    }
  }

  return (
    <p className="card-wrapper__header-price">
      <strong>{priceText}</strong> {stageText}
    </p>
  );
};
